// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3_SkN","inputWrap":"CustomTip_inputWrap__2CxzY"};